import { track } from "../analytics"
import { CsError } from "../CsError"

interface BaseApiRequestOptions {
  url: string
  init: RequestInit
  trackingEvent: string
}

const DEFAULT_ERROR_MESSAGE = 'An unknown error occurred'

export async function baseApiRequest<TResponse>({
  url,
  init,
  trackingEvent,
}: BaseApiRequestOptions) {
  const res = await fetch(url, init)

  if (res.ok) {
    try {
      const jsonResponse = (await res.json()) as TResponse
      return jsonResponse
    } catch (e) {
      track('error', trackingEvent, {}, {
        message: 'Empty success response, returning empty object',
        error: JSON.stringify(e),
      })
      return {} as TResponse
    }
  } else {
    let userErrorMessage = DEFAULT_ERROR_MESSAGE
    try {
      const errorFromResponse = await res.json()
      if (errorFromResponse?.userErrorMessage) {
        userErrorMessage = errorFromResponse.userErrorMessage
      }
    } catch (e) {
      track('error', trackingEvent, {}, {
        message: 'Failed to parse error response as JSON',
        error: JSON.stringify(e),
      })
    }
    throw new CsError().withUserErrorMessage(userErrorMessage).withStatusCode(res.status)
  }
}
